<template>
  <section class="closing">
    <div class="wrap">
      <div class="stack" style="gap:10px"><h2 class="slogan">Make it happen.</h2><p style="font-family:var(--display);font-size:19px;font-weight:500">{{ site.seasonLabel }} is in session now. Teach, give or partner with us.</p></div>
      <div class="cta-row"><router-link class="btn btn-primary" to="/support">Become a volunteer teacher</router-link><router-link class="btn btn-ghost" to="/support#give">Give</router-link></div>
    </div>
  </section>
</template>

<script>
import { SITE } from '@/data/site';

export default {
  name: 'SiteClosing',
  data: () => ({ site: SITE }),
};
</script>
